import angular from 'angular';

angular
  .module('cloudX')
  .controller('EmployeeProfileOverviewCtrl', [
    'resourceFactorySvc',
    'flySvc',
    'dialogsSvc',
    'ModalService',
    employeeProfileOverviewCtrl,
  ]);

function employeeProfileOverviewCtrl(resourceFactorySvc, flySvc, dialogsSvc, ModalService) {
  var vm = this;
  var resource = resourceFactorySvc.get('employeeProfile');

  const retrieveProfiles = () => {
    resource.overview().$promise.then(
      result => (vm.employeeProfiles = result),
      error => {
        vm.employeeProfiles = [];
        console.error(error);
      },
    );
  };
  retrieveProfiles();

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
  };

  vm.submit = function(employeeProfile, value, field) {
    if (angular.equals(employeeProfile[field], value)) return false;
    if (!value) return false;

    var model = angular.copy(employeeProfile);
    model[field] = value;

    resource.update(model).$promise.then(
      function(result) {
        if (result) {
          flySvc.success('msgConfirmChange');
          return true;
        }
        return '';
      },
      function(error) {
        showError(error);
        return '';
      },
    );
  };

  vm.delete = function(employeeProfile) {
    if (!employeeProfile.id || employeeProfile.isDefault) return false;

    return dialogsSvc.showYesNo('comfirmDeleteTitle', 'msgConfirmDeleteEmployeeProfile').then(
      function(result) {
        resource.delete({ id: employeeProfile.id }).$promise.then(function() {
          var idx = vm.employeeProfiles.indexOf(employeeProfile);
          if (idx >= 0) vm.employeeProfiles.splice(idx, 1);
          flySvc.success('msgConfirmChange');
        }, showError);
        return true;
      },
      function() {
        return false;
      },
    );
  };

  vm.add = function() {
    ModalService.showModal({
      template: require('../dialogs/addEmployeeProfileDialog.html'),
      controller: 'AddEmployeeProfileDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(employeeProfile) {
        if (!employeeProfile) return;
        vm.employeeProfiles.push(employeeProfile);
        flySvc.success('msgConfirmChange');
      });
    });
  };

  vm.setDefault = function(employeeProfile) {
    if (!employeeProfile.id || employeeProfile.isDefault) return;
    resource.setDefault(
      { id: employeeProfile.id },
      null,
      function(result) {
        if (result && result.length) {
          result.forEach(p => {
            var profile = vm.employeeProfiles.find(x => x.id === p.id);
            if (profile) profile.isDefault = p.isDefault;
          });
        }

        flySvc.success('msgConfirmChange');
      },
      function(error) {
        showError(error);
        return '';
      },
    );
  };
}
